<script>
import _ from "lodash";
import { Btn, BtnGroup, Modal } from "uiv";
export default {
  components: { Btn, BtnGroup, Modal },
  props: {
    src: { type: Object, required: true },
    btnSize: { type: String, required: false, default: "sm" },
    btnType: { type: String, required: false, default: "default" },
    btnBlock: { type: Boolean, required: false, default: true },
    btnStyle: { type: Object, required: false, default: () => {} },
    monedaShow: { type: String, required: false, default: "USD" }
  },
  data() {
    return {
      show: false,
      moneda: this.monedaShow
    };
  },
  computed: {
    monedas() {
      return _.map(this.src.debug, item => {
        return item.moneda;
      });
    },
    rule() {
      return this.src.debug[this.moneda];
    }
  }
};
</script>

<template>
  <div>
    <btn
      :block="btnBlock"
      :size="btnSize"
      :type="btnType"
      @click="show=true"
      :style="btnStyle"
      title="Rules detalle"
    >
      <slot>
        <i class="mdi mdi-calculator"></i> Rules detalle
      </slot>
    </btn>

    <modal v-model="show" :footer="false" :append-to-body="true" class="rules-modal">
      <template slot="title">
        <select class="form-control" v-model="moneda">
          <option v-for="item in monedas" v-bind:value="item" v-text="item" :key="item"></option>
        </select>
      </template>

      <table class="table table-condensed table-hover table-rules-debug">
        <tbody>
          <tr class="monto info">
            <th class="text-left">Concepto</th>
            <th class="text-center">Monto</th>
          </tr>

          <tr class="monto warning">
            <th>Base Fare</th>
            <td v-text="rule.base_fare"></td>
          </tr>

          <tr class="monto warning">
            <th>Taxes</th>
            <td v-text="rule.taxes"></td>
          </tr>

          <template v-for="(item, key) in rule.rules">
            <tr class="monto active" :key="'a-' + key">
              <th v-text="item.nombre"></th>
              <td v-text="item.monto"></td>
            </tr>

            <tr class="rule" :key="'b-' + key">
              <th>Valor Tipo</th>
              <td v-text="item.valor_tipo"></td>
            </tr>
            <tr class="rule" :key="'c-' + key">
              <th>Valor Sobre</th>
              <td v-text="item.valor_sobre"></td>
            </tr>
            <tr class="rule" :key="'d-' + key">
              <th>Agrupamiento</th>
              <td v-text="item.agrupamiento"></td>
            </tr>
            <tr class="rule" :key="'e-' + key">
              <th>Moneda</th>
              <td v-text="item.moneda"></td>
            </tr>
          </template>
        </tbody>
        <tfoot>
          <tr class="monto success">
            <th>Total Fare</th>
            <td v-text="rule.total_fare"></td>
          </tr>
        </tfoot>
      </table>
    </modal>
  </div>
</template>
